/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthScoreMetricResponseModel } from '../../models/health-score-metric-response-model';
import { HealthScoreRequestModel } from '../../models/health-score-request-model';

export interface IntegrationHealthScoreMetricsPersonIdPost$Params {

/**
 * Person identifier.
 */
  personId: string;
  
    /**
     * Health score request with date range.
     */
    body?: HealthScoreRequestModel
}

export function integrationHealthScoreMetricsPersonIdPost(http: HttpClient, rootUrl: string, params: IntegrationHealthScoreMetricsPersonIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<HealthScoreMetricResponseModel>> {
  const rb = new RequestBuilder(rootUrl, integrationHealthScoreMetricsPersonIdPost.PATH, 'post');
  if (params) {
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<HealthScoreMetricResponseModel>;
    })
  );
}

integrationHealthScoreMetricsPersonIdPost.PATH = '/Integration/HealthScoreMetrics/{personId}';
